let workingTime = process.env.NODE_ENV === 'testing' ? 0.1 * 60 : 5 * 60
export const WORKING_TIME = workingTime
export const RESTING_TIME = 5 * 60
export const KITTEN_TIME = 5



// WEBPACK FOOTER //
// ./src/config.js